export const TRAKTO_TEST_IDS = {
    TRAKTO_BUTTON: 'trakto-button-test',
    DOCUMENTS_TABLE: 'trakto-documents-table',
    TEMPLATES_TABLE: 'trakto-templates-table',
};

export const TRAKTO_TEXTS = {
    TEMPLATES: {
        TITLE: 'Templates',
    },
    DOCUMENTS: {
        TITLE: 'Your Layouts',
        CREATE_BUTTON: 'New Layout',
        LOADING: 'Loading',
    },
    ICONS: {
        PENCIL: {
            ALT: 'Edit',
        },
        TRASH: {
            ALT: 'Delete',
        },
    },
    TOAST_TEXT: {
        SUCCESS: 'Layout shared successfully! User {0} can find it in his Pareto Ads account.',
        ERROR: 'This email is not from a Pareto Ads user. Please try another email.',
        ERROR_SHARED_YOURSELF: "You can't share a layout with yourself. Please, try another email.",
    },
};
